import { GET_SECURITY_QUESTION } from "../../actionTypes/actionsTypes";
import { ActionPayload, AppAction, BaseAsyncReducerState } from "../../types";

// Define an initial state value for the app
const initialState: BaseAsyncReducerState = {
    loading: false,
    error: false
}
  
function getSecurityQuestionReducer(state = initialState, action: AppAction) {

    const { payload } = action;

    switch (action.type) {
        case GET_SECURITY_QUESTION.PENDING:
            return {
                ...state,
                loading: true,
                error: false,
            }
        case GET_SECURITY_QUESTION.SUCCESS:

            return {
                ...state,
                ...payload as ActionPayload,
                loading: false,
                error: false,

            }

        case GET_SECURITY_QUESTION.ERROR:
            return {
                ...state,
                loading: false,
                error: payload
            };

        default:
            // If the reducer doesn't care about this action type,
            // return the existing state unchanged
            return state
    }
}

export default getSecurityQuestionReducer;